/* eslint-disable react/jsx-props-no-spreading */
import {
  ListManager, PageHeader, Paginator, Styles,
} from '@/components'
import { Button } from '@/components/styles'
import useAxiosRequest from '@/hooks/useAxiosRequest'
import usePageTitle from '@/hooks/usePageTitle'
import useQuery from '@/hooks/useQuery'
import mistreatmentTypes from '@/services/api/mistreatmentTypes'
import React from 'react'
import FormMistreatmentType from './components/Form'
import Row from './components/Row'

// import { Container } from './styles';

function MistreatmentTypes({ title }) {
  usePageTitle({ title })
  const query = useQuery()

  const {
    data, loading, error, setData,
  } = useAxiosRequest(mistreatmentTypes.list, query)

  function onAdded(newMistreatmentType) {
    if (data) {
      const newData = {
        ...data,
        rows: [newMistreatmentType, ...data.rows],
        count: data.count + 1,
      }
      setData(newData)
    }
  }

  function onUpdated(updatedMistreatmentType) {
    if (data) {
      const newData = {
        ...data,
        rows: data.rows.map(
          (mt) => (mt.id === updatedMistreatmentType.id ? updatedMistreatmentType : mt),
        ),
      }
      setData(newData)
    }
  }

  return (
    <Styles.Container className="grid-xl">
      <PageHeader
        title="Tipos de denúncia"
        icon="fas fa-list"
        subtitle="Gerencie os tipos de denúncia"
        rightAction={() => (
          <>
            <FormMistreatmentType
              onSuccess={onAdded}
              ButtonComponent={(props) => (
                <Button {...props} className="btn-primary">
                  <i className="fas fa-plus" />
                  &nbsp;Adicionar
                </Button>
              )}
            />
          </>
        )}
      />
      <ListManager count={data?.count ?? 0} loading={loading} error={error}>
        <>
          <table className="table table-striped table-hover">
            <thead>
              <tr>
                <th width="200px">Título</th>
                <th>Descrição</th>
                <th width="1" className="text-right">Situação</th>
                <th width="90px" className="text-right">Ações</th>
              </tr>
            </thead>
            <tbody>
              {
                (data?.rows ?? []).map((mistreatmentType) => (
                  <Row
                    key={String(mistreatmentType.id)}
                    mistreatmentType={mistreatmentType}
                    onUpdated={onUpdated}
                  />
                ))
              }
            </tbody>
          </table>
          {
            Boolean(data) && (
              <div className="my-2">
                <Paginator paginatedList={data} />
              </div>
            )
          }
        </>
      </ListManager>
    </Styles.Container>
  )
}

export default MistreatmentTypes
